import http from '@services/http'
import { CompanyMedia, ICompaniesModule, ICompanyDetails, ICompanyDocument } from '@store/companyStore/type'

export default {
    getCompany(id: number): Promise<any> {
        return http.get(`Companies/GetCompany`, { companyId: id })
    },
    createOrUpdateCompany(company: ICompanyDetails): Promise<any> {
        return http.post(`Companies/CreateOrUpdateCompany`, company)
    },
    insertCompanyDocument(doc: ICompanyDocument): Promise<ICompanyDocument> {
        return http.post(`Companies/InsertCompanyDocument`, doc)
    },
    deleteCompanyDocument(doc: ICompanyDocument): Promise<any> {
        return http.delete(`Companies/DeleteCompanyDocument`, { CompanyDocumentId: doc.id })
    },
    createOrUpdateCompanyModule(module: ICompaniesModule): Promise<any> {
        return http.post(`Companies/CreateOrUpdateCompanyModule`, module)
    },
    getModuleSettings(moduleSettingId: number, companyId: number): Promise<any> {
        return http.get(`Modules/GetModuleSettings`, { moduleSettingId: moduleSettingId, companyId: companyId })
    },
    getDefaultMedia(): Promise<CompanyMedia> {
        return http.get(`Companies/GetDefaultCompanyMedia`, {})
    },
    getAvailableCompanyId(): Promise<number> {
        return http.get(`Companies/GetAvailableCompanyId`, {})
    },
    updateRegistrationInTaagid(companyId: number, taagidId: number): Promise<any> {
        return http.post(`Companies/UpdateRegistrationInTaagid`, { companyId: companyId, taagidId: taagidId })
    }
}
